const validateKeyword = (value: string, keywords: string[]) => {
  const trimmedWord = value.trim();
  if (!trimmedWord) return 'Label cannot be empty';

  if (keywords.includes(trimmedWord)) {
    return 'Label already used. Please enter a unique label';
  }

  return true;
};

export { validateKeyword };
